import { useEffect } from "react";
import FinancingHero from "@/components/financing/FinancingHero";
import FinancingCards from "@/components/financing/FinancingCards";
import PropertyTypes from "@/components/financing/PropertyTypes";
import FinanceTeam from "@/components/financing/FinanceTeam";
import FundingForm from "@/components/financing/FundingForm";
import FundingCta from "@/components/financing/FundingCta";
import { useScrollToTarget } from "@/hooks/useScrollToTarget";

export default function Financing() {
  useScrollToTarget();
  useEffect(() => {
    const prev = document.title;
    document.title = "Commercial Real Estate Financing | Veritas Development Group LLC";
    return () => {
      document.title = prev;
    };
  }, []);
  return (
    <>
      <FinancingHero />
      <FinancingCards />
      <PropertyTypes />
      <FinanceTeam />
      <FundingForm />
      <FundingCta />
    </>
  );
}
